<template>
  <router-view :key="key"></router-view>
</template>

<script>
export default {
  name: 'App',
  computed: {
    key () {
      return this.$route.name !== undefined ? this.$route.name + new Date() : this.$route + new Date()
    }
  },
  created () {
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
<style>
body,html{margin:0px;padding:0px;color:#333333;position: relative;}
ul,li{list-style: none;padding-left:0px;}
.el-button--primary{background: #B6242B;color:#FFFFFF;border:1px solid #B6242B;}
.el-button--primary:hover,.el-button--primary:active,.el-button--primary:visited,.el-button--primary:focus{background: #B6242B;color:#FFFFFF;border:1px solid #B6242B;}
.el-button--text{color:#B6242B;}
.el-button--text:active,.el-button--text:focus,.el-button--text:hover,.el-button--text:visited{color:#B6242B;}
.el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover{background-color:#B6242B;border:1px solid #B6242B}
</style>



// WEBPACK FOOTER //
// src/App.vue